import { gql } from "@/__generated__/gql";

export const RISE_APPLY_INDEX_SUMMARY = gql(`
query riseApplyIndexSummary($orgId: ID!, $cohortYear: Int!, $inCommunity: YesNoEnum) {
  node(id: $orgId) {
    id
    ... on Organization {
      rise {
        applyIndexSummary(cohortYear: $cohortYear, inCommunity: $inCommunity) {
          low {
            state
            value
          }
          mediumLow {
            state
            value
          }
          medium {
            state
            value
          }
          mediumHigh {
            state
            value
          }
          high {
            state
            value
          }
        }
      }
    }
  }
}
`);
